import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/down.png'
import _imports_1 from '../../assets/img/top.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-b3f15c62")

_pushScopeId("data-v-b3f15c62")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "mar-r-8 mar-t-12" }, "选择门店", -1)
const _hoisted_4 = {
  class: "f-18 w-500 mar-t-24 mar-b-10",
  style: {"line-height":"26px"}
}
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "f-40 mar-t-35 flex alignC flexC" }
const _hoisted_7 = {
  key: 0,
  class: "wh-32",
  src: _imports_0,
  alt: ""
}
const _hoisted_8 = {
  key: 1,
  class: "wh-32",
  src: _imports_1,
  alt: ""
}
const _hoisted_9 = { class: "f-18 mar-t-24" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.userinfo)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_el_select, {
            modelValue: _ctx.screenParameter.store_id,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.screenParameter.store_id = $event)),
            onChange: _ctx.getTableData,
            placeholder: "请选择",
            class: "mar-t-12"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.Framework, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.store_name,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataStatistics, (a, b) => {
      return (_openBlock(), _createBlock("div", {
        key: b,
        class: "mar-b-10"
      }, [
        _createVNode("h3", _hoisted_4, _toDisplayString(a.title), 1),
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(a.data_list, (c, d) => {
            return (_openBlock(), _createBlock("div", {
              key: d,
              class: "item"
            }, [
              _createVNode("div", _hoisted_6, [
                _createTextVNode(_toDisplayString(c.number) + " ", 1),
                (c.status == 0)
                  ? (_openBlock(), _createBlock("img", _hoisted_7))
                  : _createCommentVNode("", true),
                (c.status == 1)
                  ? (_openBlock(), _createBlock("img", _hoisted_8))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_9, _toDisplayString(c.title), 1)
            ]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
})